/**
 * Layout trang chủ — header tìm kiếm (HomeHeader) + nội dung + footer.
 *
 * Dùng cho route `/` và các trang public có thanh category/tìm kiếm nổi bật.
 */
import { Outlet } from 'react-router-dom';
import { Footer } from '../components/Common/Footer';
import { HomeHeader } from '../components/home/HomeHeader';

/** Shell layout trang chủ với HomeHeader thay Header thường */
export const HomeLayout = () => (
  <div className="app-shell app-shell--home">
    <HomeHeader />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);
